import types, {
  DELETE_ADDRESS_ACTION_TYPE,
  EDIT_PROFILE_ACTION_TYPE,
  ORDERS_NEEDS_ACTION_ACTION_TYPE,
} from "./types";

function add_single_address(payload) {
  return { type: types.ADD_SINGLE_ADDRESS, payload };
}

function set_user_address(payload) {
  return { type: types.SET_ADDRESS, payload };
}

function set_orders_action(payload) {
  return { type: types.SET_ORDERS, payload };
}
function set_transactions_action(payload) {
  return { type: types.SET_TRANSACTIONS, payload };
}
function set_profile_action(payload) {
  return { type: types.SET_PROFILE, payload };
}

function set_groups_action(payload) {
  return { type: types.SET_GROUPS, payload };
}

function set_selected_group_action(payload) {
  return { type: types.SET_SELECTED_GROUP, payload };
}

function delete_address_action(payload: { address_id: string | number }) {
  return { type: DELETE_ADDRESS_ACTION_TYPE, payload };
}

function edit_profile_action(payload: {
  first_name?: string;
  last_name?: string;
  email?: string;
}) {
  return { type: EDIT_PROFILE_ACTION_TYPE, payload };
}

function set_orders_needs_action_action(payload) {
  return { type: ORDERS_NEEDS_ACTION_ACTION_TYPE, payload };
}

function set_reset_action() {
  return { type: types.SET_RESET };
}

export {
  set_user_address,
  set_orders_action,
  set_transactions_action,
  set_profile_action,
  set_groups_action,
  set_selected_group_action,
  add_single_address,
  delete_address_action,
  edit_profile_action,
  set_orders_needs_action_action,
  set_reset_action,
};

// old
export default {
  login: (payload) => ({ type: types.LOGIN_REQUEST, payload }),
  set_phone: (payload) => ({ type: types.LOGIN_SET_PHONE, payload }),
  login_verify: (payload) => ({ type: types.LOGIN_VERIFY, payload }),
  set_profile: set_profile_action,
  set_token: (payload) => ({ type: types.SET_TOKEN, payload }),
  user_address_request: (payload) => ({
    type: types.USER_ADRESS_REQUEST,
    payload,
  }),
  set_user_address,
  add_address_request: (payload) => ({
    type: types.ADD_ADRESS_REQUEST,
    payload,
  }),
  set_orders: set_orders_action,
  get_orders: (payload) => ({ type: types.GET_ORDERS, payload }),
};
